document.addEventListener("DOMContentLoaded", function () {
  const elements = document.querySelectorAll(".Media_inner_new");

  const observer = new IntersectionObserver(
    (entries, observer) => {
      entries.forEach((entry) => {
        if (entry.intersectionRatio >= 0.4) {
          entry.target.classList.add("active");
          observer.unobserve(entry.target); // runs once only
        }
      });
    },
    {
      threshold: 0.4, // 👈 40% visible
    }
  );

  elements.forEach((el) => observer.observe(el));
});